export default __webpack_public_path__ + "static/media/4.2f3a7a41.jpg";